module.exports = __webpack_public_path__ + "assets/img/17_961.71bf3d55.jpg";